import '@angular/compiler';
import { enableProdMode, ErrorHandler, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { HttpLoaderFactory } from './app/app.module';
import { environment } from './environments/environment';
import translations from './assets/i18n/en.json';
import { detect } from 'detect-browser';
import { serverUrlProvider } from './app/providers/server-url.provider';
import { isUserLoggedInProvider } from './app/providers/is-user-logged-in.provider';
import { AlarmIconLinkPipe } from './app/pipes/alarm-icon-link.pipe';
import { versionToken, AuthService, TestAuthService, TestInterceptor, TokenInterceptor, sentryConfig, SentryErrorHandler, SharedModule } from 'shared';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { PathInterceptor } from './app/interceptors/path.interceptor';
import { Angulartics2LaunchByAdobe, Angulartics2Module } from 'angulartics2';
import { UserTrackingService } from './app/services/user-tracking.service';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AppComponent } from './app/app.component';
import packageInfo from 'package.json';

const version = packageInfo.version;
const testModeProviders = [
  {
    provide: AuthService,
    useClass: TestAuthService,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TestInterceptor,
    multi: true,
  },
];



if (environment.production) {
  enableProdMode();
}

if (!sessionStorage.getItem('customerportal.browser-warning-shown')) {
  sessionStorage.setItem('customerportal.browser-warning-shown', 'true');
  const detectedBrowser = detect();
  if (detectedBrowser) {
    const isBrowserSupported = ['chrome', 'firefox'].includes(detectedBrowser.name);

    const isDeviceSupported = screen.width > 1024;

    if (!isDeviceSupported || !isBrowserSupported) {
      alert(translations['unsupported-device-or-browser']);
    }
  }
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(CdkStepperModule, SharedModule, BrowserModule, ReactiveFormsModule, FormsModule, AppRoutingModule, HighchartsChartModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }), OverlayModule, NgxDatatableModule, Angulartics2Module.forRoot({
            //developerMode: !environment.production, // Enable this if you want to load the tracking script in dev but disable actual tracking
            pageTracking: { autoTrackVirtualPages: true, excludedRoutes: [/callback#state/g, /silent-renew.html/g] },
        })),
        serverUrlProvider,
        isUserLoggedInProvider,
        AlarmIconLinkPipe,
        {
            provide: versionToken,
            useValue: version,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PathInterceptor,
            multi: true,
        },
        {
            provide: sentryConfig,
            useValue: {
                dsn: 'https://0416bf35d1ed4c6fbc641cce21752012@sentry.io/2851033',
                release: 'customer-portal@' + version,
                enabled: environment.production,
            },
        },
        {
            provide: ErrorHandler,
            useClass: SentryErrorHandler,
        },
        {
            provide: LOCALE_ID,
            useValue: 'en-DK',
        },
        {
            provide: Angulartics2LaunchByAdobe,
            useClass: UserTrackingService,
        },
        // Test environment stuff
        ...(environment.testMode ? testModeProviders : []),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));

